// useQueueCount.ts — real-time mutation queue -counter.
// Päivittyy kun mutaatioita lisätään / poistetaan / synkronoituu.

import { useEffect, useState } from 'react';
import { count, onQueueChange } from '../utils/mutationQueue';

export function useQueueCount(): number {
  const [n, setN] = useState(0);

  useEffect(() => {
    let mounted = true;
    const refresh = async () => {
      const c = await count();
      if (mounted) setN(c);
    };
    refresh();
    const unsub = onQueueChange(refresh);
    const onSynced = () => refresh();
    window.addEventListener('queue:synced', onSynced);
    return () => {
      mounted = false;
      unsub();
      window.removeEventListener('queue:synced', onSynced);
    };
  }, []);

  return n;
}
